module.exports = __webpack_public_path__ + "static/roboto-mono-v7-latin-italic-2820fa2acd542ff7b04d97821392d566.woff2";